import React from "react";
import "./Banner.css";

export default function Banner() {
  return (
    <div className="banner">
      <div className="container">
        <div className="home">
          <h1 className="home_name">
            Raqamli ta‘lim resursi <br /> Platformasi
          </h1>
        </div>
      </div>
    </div>
  );
}
